import { render, staticRenderFns } from "./about-home.vue?vue&type=template&id=02ef8f37&scoped=true"
import script from "./about-home.vue?vue&type=script&lang=js"
export * from "./about-home.vue?vue&type=script&lang=js"
import style0 from "./about-home.vue?vue&type=style&index=0&id=02ef8f37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ef8f37",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
